<!-- FilePreviewModal.vue -->
<template>
  <b-modal size="xl" v-model="showModal" hide-footer no-close-on-backdrop @hidden="modalHidden">
    <!-- Custom header: title on the left, caller-provided actions + close at the top right -->
    <template #modal-header="{ close }">
      <div class="fp-header">
        <h5 class="fp-header__title">{{ title }}</h5>
        <div class="fp-header__actions">
          <slot name="actions"></slot>
          <button type="button" aria-label="Close" class="close fp-header__close" @click="close()">&times;</button>
        </div>
      </div>
    </template>
    <div class="file-content">
      <!-- No bytes (file missing on this server) — placeholder, actions stay usable -->
      <div v-if="!fileUrl" class="file-content__missing">
        <i class="fa-solid fa-file-circle-exclamation"></i>
        <div class="file-content__missing-text">{{ $t('globalMessages.filePreviewUnavailable') }}</div>
      </div>
      <!-- Images: fixed frame — always contained, never natural (huge) size -->
      <img v-else-if="isImage" :src="fileUrl" class="file-content__img" alt=""/>
      <!-- PDFs / everything else: full width, fixed height -->
      <object v-else :data="fileUrl" :type="fileType" class="file-content__doc"></object>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }, // Use a prop to control the modal visibility
    fileUrl: String, // URL of the file content
    fileType: String, // Content type of the file (e.g., 'application/pdf')
    title: {
      type: String,
      default: 'File Preview'
    },
  },
  computed: {
    isImage() {
      return (this.fileType || '').startsWith('image/');
    },
  },
  methods: {
    modalHidden() {
      this.$emit('close'); // Emit a close event to notify the parent component
    },
  },
};
</script>

<style scoped>
.fp-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.fp-header__title {
  margin: 0;
}
.fp-header__actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.fp-header__close {
  margin-left: 0.75rem;
  font-size: 1.5rem;
  line-height: 1;
}
.file-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.file-content__missing {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 3rem 1rem;
  color: #8592a3;
  text-align: center;
}
.file-content__missing i {
  font-size: 2.5rem;
  opacity: 0.6;
}
.file-content__missing-text {
  max-width: 420px;
}
.file-content__img {
  max-width: 100%;
  max-height: 70vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
}
.file-content__doc {
  width: 100%;
  height: 75vh;
}
</style>
